import { useSelector } from 'react-redux'
import useToast, { Type } from '../../../hooks/useToast'
import Button from '../../../UI/Button/Button'
import props from '../../../../redux/props'

const Copy = ({ text }) => {
  const toast = useToast()
  const t = useSelector((s) => s[props.TRANSLATION])

  const copyValue = () => {
    navigator.clipboard.writeText(text)
    toast(t.naw.survey.list.copySuccess, Type.SUCCESS)
  }

  return (
    <div className="btn" onClick={copyValue}>
      <Button text={t.generic.copy} onClick={copyValue} />
    </div>
  )
}

export default Copy
